import COM from './Filter'

export default COM
